import {useMutation, UseMutationResult, useQueryClient} from "@tanstack/react-query";
import {CustomAxiosError, useApiCalls} from "../../../../../../logics/api_config";
import {useAuth} from "../../../../../../utils/contexts/auth-context";
import {IWasteCode} from "../../../../../../utils/interfaces/special_wasty/waste_code/IWasteCode";


const useApiUpdateWasteCode = (site_id: number | undefined): UseMutationResult<IWasteCode, CustomAxiosError, {
    id: number;
    data: any
}, unknown> => {
    const queryClient = useQueryClient();
    const {selectedCompany} = useAuth()

    const {put} = useApiCalls()


    async function doUpdate(company_token: string | undefined,
                            pk: number | undefined,
                            data: any): Promise<IWasteCode> {
        try {
            const response = await put(`/api/company/${company_token}/special_wasty/waste_code/${pk}?site_id=${site_id}`, data);
            return response.data as IWasteCode;
        } catch (error) {
            throw error;
        }
    }

    return useMutation<IWasteCode, CustomAxiosError, {
        id: number;
        data: any
    }, unknown>({
        mutationFn: async ({id, data}) => {
            return await doUpdate(selectedCompany?.company_token, id, data);
        },
        onSuccess: async (data) => {
            await queryClient.invalidateQueries({queryKey: ['useApiGetWasteCode', data.id, site_id]});
            await queryClient.invalidateQueries({queryKey: ['useApiGetWasteCodes', site_id]});
        },
    });
};


export default useApiUpdateWasteCode;